import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BadgeComponent } from '../../../components/badge/badge.component';

@Component({
  selector: 'app-access-item-header',
  imports: [BadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './access-item-header.component.html',
  styleUrl: './access-item-header.component.scss',
})
export class AccessItemHeaderComponent {
  comingSoon = input<boolean>(false);
}
